import { NgModule } from '@angular/core';
import { ProvidersComponent } from "./providers.component";
import { FilterService } from "../core/services/index";
import { Ng2PaginationModule } from "ng2-pagination";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared/shared.module";
import { CustomFormsModule } from "ng2-validation/dist";
import { ReactiveFormsModule } from "@angular/forms";

@NgModule({
    imports: [CommonModule, SharedModule, Ng2PaginationModule, ReactiveFormsModule, CustomFormsModule],
    exports: [],
    declarations: [ProvidersComponent],
    providers: [FilterService],
})
export class ProviderModule { }



// WEBPACK FOOTER //
// ./src/app/providers/provider.module.ts